import { Link } from "react-router-dom";
import { scrollTo } from "@/components/Header";
import { useLanguage } from "@/hooks/use-language";

export const Footer = () => {
  const { t } = useLanguage();
  const LINKS = [
    { label: t.nav.platform, href: "#platform" },
    { label: t.nav.architecture, href: "#architecture" },
    { label: t.nav.benchmark, href: "#benchmark" },
    { label: t.nav.security, href: "#security" },
    { label: t.nav.team, href: "#team" },
    { label: t.footer.contact, href: "#contact" },
  ];

  return (
  <footer className="border-t border-border" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 flex flex-col md:flex-row md:items-end justify-between gap-10">
      <div>
        <div>
          <img
            src="/logo-transparent.webp"
            alt="Streamline360"
            className="h-9 w-auto"
          />
        </div>
        <p className="mt-4 max-w-xs text-sm text-muted-foreground">
          {t.footer.tagline}
        </p>
      </div>
      <nav className="flex flex-wrap gap-x-8 gap-y-3">
        {LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            onClick={(e) => { e.preventDefault(); scrollTo(l.href); }}
            className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
          >
            {l.label}
          </a>
        ))}
      </nav>
    </div>
    <div className="border-t border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 flex flex-col md:flex-row justify-between gap-6">
        <div data-testid="impressum">
          <p className="font-display text-xs tracking-[0.3em] uppercase text-muted-foreground mb-3">{t.footer.impressum}</p>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Streamline360 ApS · VAT nr. DK46390261
            <br />
            Vestergade 29, DK-1456 Copenhagen
          </p>
          <div className="mt-4 flex gap-5 text-xs">
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-muted-foreground hover:text-teal-600 dark:hover:text-teal-400 transition-colors duration-300 uppercase tracking-[0.2em]">
              {t.footer.privacy}
            </Link>
            <Link to="/terms" data-testid="footer-terms-link" className="text-muted-foreground hover:text-teal-600 dark:hover:text-teal-400 transition-colors duration-300 uppercase tracking-[0.2em]">
              {t.footer.terms}
            </Link>
          </div>
        </div>
        <p className="text-sm text-muted-foreground max-w-xs md:text-right">
          {t.footer.madeIn}
        </p>
      </div>
    </div>
    <div className="border-t border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-muted-foreground/70">
        <span>{t.footer.rights}</span>
        <span>{t.footer.neverLeaves}</span>
      </div>
    </div>
  </footer>
  );
};
